import { useTranslation } from 'react-i18next';

export default function AlternativeContact() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/40">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-10">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('brochure.alt.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('brochure.alt.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('brochure.alt.subtitleEn')}
          </p>
          <div className="gold-line mx-auto mb-5"></div>
          <p className="text-[15px] text-foreground-600 tracking-[0.04em] leading-relaxed">
            {t('brochure.alt.lead')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
          {/* Phone */}
          <div className="card-glow bg-background-50 border border-background-200/60 p-8 text-center">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500/[0.06]">
              <i className="ri-phone-line text-accent-500 text-xl"></i>
            </div>
            <h3 className="text-[15px] text-foreground-700 tracking-[0.06em] mb-3 font-label">
              {t('brochure.alt.phoneTitle', { defaultValue: 'Phone Request' })}
            </h3>
            <a
              href="tel:0368244086"
              className="block text-[20px] text-foreground-800 tracking-[0.06em] font-medium hover:text-accent-600 transition-colors mb-2"
            >
              03-6824-4086
            </a>
            <p className="text-[14px] text-foreground-500 tracking-[0.03em]">
              {t('brochure.alt.phoneHours')}
            </p>
          </div>

          {/* Email */}
          <div className="card-glow bg-background-50 border border-background-200/60 p-8 text-center">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500/[0.06]">
              <i className="ri-mail-line text-accent-500 text-xl"></i>
            </div>
            <h3 className="text-[15px] text-foreground-700 tracking-[0.06em] mb-3 font-label">
              {t('brochure.alt.emailTitle', { defaultValue: 'Email Request' })}
            </h3>
            <a
              href="mailto:info@butler-academy.jp"
              className="block text-[16px] text-accent-600 tracking-[0.04em] hover:text-accent-500 transition-colors break-all"
            >
              info@butler-academy.jp
            </a>
            <p className="text-[14px] text-foreground-500 tracking-[0.03em] mt-1">
              {t('brochure.alt.emailReply')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
